<template>
  <div class="space-y-6">
    <div class="flex gap-4 *:w-1/2">
      <BaseLabeledField>
        <template #label>billing</template>
        <template #field>{{ context.billingCompany.name }}</template>
      </BaseLabeledField>
      <BaseLabeledField>
        <template #label>property</template>
        <template #field>{{ context.property.name }}</template>
      </BaseLabeledField>
    </div>
    <div class="flex gap-4 *:w-1/2" v-if="context.unit">
      <BaseLabeledField>
        <template #label>building</template>
        <template #field>{{ context.unit.building }}</template>
      </BaseLabeledField>
      <BaseLabeledField>
        <template #label>unit</template>
        <template #field>{{ context.unit.name }}</template>
      </BaseLabeledField>
    </div>
    <div class="flex gap-4 *:w-1/2" v-if="context.unit">
      <BaseLabeledField v-if="context.unit.utilityType">
        <template #label>meter {{ context.unit.portTwoUtilityType ? '1' : '' }}</template>
        <template #field
          ><i
            :class="context.unit.utilityType.iconName"
            class="mr-1"
            :style="{ color: context.unit.utilityType.colorHex }"
          ></i
          >{{ context.unit.utilityType.name }}</template
        >
      </BaseLabeledField>
      <BaseLabeledField v-if="context.unit.portTwoUtilityType">
        <template #label>meter 2</template>
        <template #field
          ><i
            :class="context.unit.portTwoUtilityType.iconName"
            :style="{ color: context.unit.portTwoUtilityType.colorHex }"
            class="mr-1"
          ></i
          >{{ context.unit.portTwoUtilityType.name }}</template
        >
      </BaseLabeledField>
      <BaseLabeledField v-else-if="context.unit.leakSensorLocation">
        <template #label>Sensor Location</template>
        <template #field>
          <i class="icon-leak-sensor mr-1 text-gray-700"></i>{{ context.unit.leakSensorLocation }}
        </template>
      </BaseLabeledField>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseLabeledField from '@/components/BaseLabeledField.vue';
import { ProgrammedDeviceContext } from 'common';

defineProps<{
  context: ProgrammedDeviceContext;
}>();
</script>

<style scoped></style>
